import React, {forwardRef, MutableRefObject, useEffect, useState} from "react";
import { Input } from "@rebass/forms";
import {FieldHelperProps, FieldInputProps, FieldMetaProps, useField} from "formik";
import {InputHelper, InputHelperOptionalParameters} from "./InputHelper";
import {Moment} from "moment";
import styled from "styled-components";
import {StyledInputBox} from "./TextInput";
import {Flex, Text} from "rebass";

export const NumberInput: React.FC<{
  name: string;
  step?: number;
  min?: number;
  max?: number;
  decimalPlaces?: number;
  unit?: string;
  helperParameters?: InputHelperOptionalParameters;
}> = ({children, step, name, min, max, decimalPlaces , unit, helperParameters={label: name}}) => {
  const validate = (value) => {

    if (value === "") {
      return "Select a value";
    }

    if (isNaN(Number(value))) return "Select a number";
    if (min != undefined && Number(value) < min) return "Too small. Select a value >= " + min
    if (max != undefined && Number(value) > max) return "Too Large. Select a value <= " + max
  };

  const [field, meta, helpers] = useField({ name, validate });

  return (
    <InputHelper meta={meta} helpers={helpers} {...helperParameters}>
      <NumberBox value={parseInt(meta.value)} setValue={(value: number) => helpers.setValue(value.toFixed(decimalPlaces))} variant={meta.touched && meta.error ? "error" : ""} step={step} min={min} max={max} decimalPlaces={decimalPlaces} unit={unit}/>
    </InputHelper>
  );
};



export const NumberBox = forwardRef(
  (
    {value, setValue, variant, onBlur, step, min, max, decimalPlaces, unit, placeholder, onChange}: {
      value: number | null;
      setValue: (number) => void;
      variant?: string;
      onBlur?: (FocusEvent) => void;
      step?: number;
      min?: number;
      max?: number;
      decimalPlaces?: number;
      unit?: string;
      placeholder?: string;
      onChange?:  (number) => void;
    },
    ref
  ) => {

    if (decimalPlaces === undefined) decimalPlaces = 1
    if (unit === undefined) unit = ""

    const [focused, setFocused] = useState<boolean>(false)

    const stringValue = (value == null || isNaN(value))? "" : value.toFixed(decimalPlaces)
    const [displayValue, setDisplayValue] = useState<string>(stringValue)

    useEffect(()=>{
      if (!focused) setDisplayValue((value == null || isNaN(value))? "" : value.toFixed(decimalPlaces))
    }, [value])

    // @ts-ignore
    const calculateWidth = (str: string) => [...str.matchAll(/[0-9]/g)].length * 12 + str.includes('.') * 4 + str.includes('-') * 6 + [...str.matchAll(/[a-z]/g)].length * 12

    let longestValue = [max || 0, min || 0, value].reduce((a, b) => ((a?.toFixed(decimalPlaces)?.length || 0) > (b?.toFixed(decimalPlaces)?.length || 0))? a:b)

    let dynamicBuffer =  calculateWidth(longestValue?.toFixed(decimalPlaces) || "") + calculateWidth(unit)

    const displayInputOnlyUnits = ['min'];
    if(displayInputOnlyUnits.includes(unit)){
      let newDisplayVal: any = displayValue;
      if(unit == 'min'){
        newDisplayVal = parseFloat(displayValue)/60;
      }
      return (
        <Flex style={{width: dynamicBuffer + "px"}}>
            <StyledInputBox
              style={{textAlign: "center", display: "none"}}
              width={Math.max(calculateWidth(value?.toFixed(decimalPlaces) || ""), calculateWidth(displayValue), 40)}
              step={step}
              onBlur={(e) => {
                let newValue = displayValue? Number(displayValue):NaN
                if (!isNaN(newValue)) {
                  console.log("new value", newValue)
                  // autocorrect values
                  if (max) newValue = Math.min(newValue, max)
                  if (min) newValue = Math.max(newValue, min)

                  setValue(newValue)
                  setDisplayValue(newValue.toFixed(decimalPlaces))
                } else {
                  setDisplayValue(stringValue)
                }

                setFocused(false)
                if (onBlur) onBlur(e)
              }}
              onFocus={() => setFocused(true)}
              onChange={(e) => {
                setDisplayValue(e.target.value)
                if(onChange)
                  onChange(e.target.value);
              }}
              onKeyDown={(e) => { // @ts-ignore
                if (e.code === "Enter") e.target.blur()
              }}
              value={displayValue}
              placeholder={placeholder !== undefined? placeholder:"0" + (decimalPlaces > 0 ? "." + "0".repeat(decimalPlaces) : "")}
            />
            <Text color="secondary" style={{width: calculateWidth(unit)+50, textAlign: 'right'}}>{newDisplayVal + ' ' + unit}</Text>
        </Flex>
      )
    }else{
      return (
        <Flex style={{width: dynamicBuffer + "px"}}>
            <StyledInputBox
              style={{textAlign: "center"}}
              width={Math.max(calculateWidth(value?.toFixed(decimalPlaces) || ""), calculateWidth(displayValue), 40)}
              step={step}
              onBlur={(e) => {
                let newValue = displayValue? Number(displayValue):NaN
                if (!isNaN(newValue)) {
                  console.log("new value", newValue)
                  // autocorrect values
                  if (max) newValue = Math.min(newValue, max)
                  if (min) newValue = Math.max(newValue, min)

                  setValue(newValue)
                  setDisplayValue(newValue.toFixed(decimalPlaces))
                } else {
                  setDisplayValue(stringValue)
                }

                setFocused(false)
                if (onBlur) onBlur(e)
              }}
              onFocus={() => setFocused(true)}
              onChange={(e) => {
                setDisplayValue(e.target.value)
              }}
              onKeyDown={(e) => { // @ts-ignore
                if (e.code === "Enter") e.target.blur()
              }}
              value={displayValue}
              placeholder={placeholder !== undefined? placeholder:"0" + (decimalPlaces > 0 ? "." + "0".repeat(decimalPlaces) : "")}
            />
            <Text color="secondary" style={{width: calculateWidth(unit)}}>{unit}</Text>
        </Flex>
      )
    }
  }
)



